/**
 * Coalesces rapid callbacks (scroll, resize, pointer) to at most once per frame.
 * @param {() => void} fn
 * @returns {() => void}
 */
export function rafThrottle(fn) {
  let rafId = 0;
  return function throttled() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      fn();
    });
  };
}
